import { boolean, schema } from "@anna-money/anna-web-lib/serializer";

export class AddressVerificationResult extends schema(
  {
    needPoa: boolean(),
  },
  "AddressVerificationResult",
) {}
